(ns common.widgets.table
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Stack$default" :as Stack]
            [common.mui :refer [get-table-border-color]]
            [common.util :as util]
            [uix.core :refer [$ defui]]))

(defn sort-indicators
  [sort-direction]
  (let [modifier ({:asc :table__sort-indicators--ascending
                   :desc :table__sort-indicators--descending}
                  sort-direction)]
    [:span.table__sort-indicators {:class modifier}
     [:i.material-icons.table__sort-indicator--up "arrow_drop_up"]
     [:i.material-icons.table__sort-indicator--down "arrow_drop_down"]]))

(defui table-actions
  [{:keys [sx children]}]
  ($ Stack
     {:direction "row" :justifyContent "space-between" :alignItems "center"
      :sx (util/merge-objects #js {:px 3
                                   :pt 0
                                   :pb 2
                                   :borderTopLeftRadius 5
                                   :borderTopRightRadius 5}
                              sx)}
     children))

(defn table
  [props & children]
  (into [:div.table props] children))

(defn table-row
  [{:keys [class href on-click disabled selected? sx] :as props} & children]
  (into
   ;; TODO this row is not focus-able using
   ;; the `tab` key and clickable using `space` or `enter` keys.
   ;; Discuss with Dan and Bram what they would like
   [:> Box (merge (dissoc props :class :on-click :selected? :sx)
                  {:class (flatten ["table__row" class])
                   :on-click #(when (and on-click (not disabled))
                                (on-click %))
                   :sx [{:borderBottomWidth "1px"
                         :borderBottomStyle "solid"
                         :borderBottomColor (fn [theme] (get-table-border-color theme))}
                        (when (or href on-click)
                          {:cursor "pointer"
                           "&:hover" {:backgroundColor "rgba(0, 0, 0, 0.04)"}})
                        (and selected?
                             {:backgroundColor "grey.70"})
                        (and disabled
                             {:cursor "not-allowed"
                              :color "text.disabled"
                              "& .MuiIcon-root" {:pointerEvents "none"
                                                 :color "text.disabled"}})
                        sx]})]
   children))

(defn table-head
  [props & children]
  (into [:div.table__head props] children))

(defn table-head-sortable
  [{:keys [sort-direction] :as props} child]
  [:div.table__head.table__head--sortable
   (dissoc props :sort-direction)
   child
   [sort-indicators sort-direction]])

(defn table-cell
  [props & children]
  (into [:div.table__cell props] children))

(defn table-message
  ([message] (table-message {} message))
  ([{:keys [data-testid]
     :or {data-testid "table-message"}} message]
   [table-row {}
    [:div.table__message {:data-testid data-testid} message]]))
